type ClassValue = string | false | null | undefined;

/** Concatena clases ignorando lo falso. Sin dependencia para algo de tres lineas. */
export function cn(...values: ClassValue[]): string {
  return values.filter(Boolean).join(" ");
}
